import { React, useEffect, useState } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  createGlobalGallery,
  getGlobalGallery,
  resetState,
  updateGlobalGallery,
} from "../features/GalleryImage/GalleryImageSlice";
let schema = yup.object().shape({
  category: yup.string().required("Category is Required"),
  image: yup.mixed().required("Image is Required"),
});
const AddNewscat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsCatId = location.pathname.split("/")[3];
  const newNewsCategory = useSelector((state) => state.globalGallery);
  const [imageErrorone, setImageErrorone] = useState("");
    const {
    isSuccess,
    isError,
    isLoading,
    createdGlobalGallery,
    updatedGlobalGallery,
    category,
  } = newNewsCategory;
  useEffect(() => {
    if (getNewsCatId !== undefined) {
      dispatch(getGlobalGallery(getNewsCatId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsCatId]);
  useEffect(() => {
    if (isSuccess && createdGlobalGallery) {
      toast.success("GlobalGallery Added Successfullly!");
      navigate("/admin/GalleryImage-list");
    }
    if (isSuccess && updatedGlobalGallery) {
      toast.success("GlobalGallery Updated Successfullly!");
      navigate("/admin/GalleryImage-list");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      category: category || "",
      image: null,
      
    },
    validationSchema: schema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("category", values.category);
      formData.append("image", values.image);
      formData.append("id",getNewsCatId);
      if (getNewsCatId !== undefined) {
        dispatch(updateGlobalGallery(formData));
        dispatch(resetState());
      } else {
        dispatch(createGlobalGallery(formData));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });

  return (
    <div>
      <h3 className="mb-4  title">
        {getNewsCatId !== undefined ? "Edit" : "Add"} GlobalGallery
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
        <select
            name="category"
            onChange={formik.handleChange("category")}
            onBlur={formik.handleBlur("category")}
            value={formik.values.category}
            className="form-control py-3 mt-3"
          >
            <option value="">Select Image Category</option>
            <option value="general">General</option>
            <option value="award">Award</option>
            <option value="fashion">Fashion</option>
          </select>
          <div className="error">{formik.touched.category && formik.errors.category}</div>

    
          <div className="mt-4">
            <label htmlFor="image" className="form-label">Select Image</label>
            <input
              type="file"
              id="image"
              name="image"
              accept="image/*"
              onChange={(e) => {
                formik.setFieldValue("image", e.currentTarget.files[0]);
                setImageErrorone(""); // Clear image error when a new file is selected
              }}
              className="form-control"
            />
            <div className="error">{formik.touched.image && formik.errors.image}</div>
          </div>
          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
            disabled={isLoading}
          >
            {isLoading && (
              <div className="loader"></div>
            )}
            {isLoading ? "" : getNewsCatId !== undefined ? "Edit" : "Add"} GlobalGallery
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNewscat;
